// extracted by mini-css-extract-plugin
module.exports = {"card":"_025a50318d--card--2y4x5"};